import { Col, Row } from 'react-bootstrap';
import { useItemAnalysisContext } from '../utils/itemAnalysisContext';
import '../styles/itemAnalysis.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../../../../components/Modal';
import { useEffect, useState } from 'react';
import ClassSelects from './ClassSelects';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';

const FilterSummary = ({loadClassAssignments}) => {
  const { classes, activeStep, setActiveStep, masteryScore, primaryAssignmentId, primaryAssignmentName, compare1Id, setCompare1Id, compare1Name, setCompare1Name
    , compare2Id, setCompare2Id, compare2Name, setCompare2Name, compare3Id, setCompare3Id, compare3Name, setCompare3Name, compare4Id
    , setCompare4Id, compare4Name, setCompare4Name, compare5Id, setCompare5Id, compare5Name, setCompare5Name } = useItemAnalysisContext();

  const [openClassSelect, setOpenClassSelect] = useState(false);
  const [comparers, setComparers] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);
  
  const handleNextClick = () => {
    var selectedClasses = classes.filter(x => x.selected);
    if (selectedClasses?.length > 0)
      setActiveStep(2);
  };
  const navigate = useNavigate();
  const generateReport = ()=>{
    navigate('report');
  };
  
  const handleCompareDelete = (index)=>{
    switch(index)
    {
    case 1:
      setCompare1Id(null);
      setCompare1Name('Select an Assignment...');
      break;
    case 2:
      setCompare2Id(null);
      setCompare2Name('Select an Assignment...');
      break;
    case 3:
      setCompare3Id(null);
      setCompare3Name('Select an Assignment...');
      break;
    case 4:
      setCompare4Id(null);
      setCompare4Name('Select an Assignment...');
      break;
    case 5:
      setCompare5Id(null);
      setCompare5Name('Select an Assignment...');
      break;
    }
  };
  
  useEffect(() => {
    var compareList=[];
    compareList.push({index : 1, id:compare1Id, name: compare1Name, show:compare1Id>0});
    compareList.push({index : 2, id:compare2Id, name: compare2Name, show:compare2Id>0});
    compareList.push({index : 3, id:compare3Id, name: compare3Name, show:compare3Id>0});
    compareList.push({index : 4, id:compare4Id, name: compare4Name, show:compare4Id>0});
    compareList.push({index : 5, id:compare5Id, name: compare5Name, show:compare5Id>0});
    setComparers(compareList);

  }, [compare1Id, compare2Id, compare3Id, compare4Id, compare5Id]);

  return (<>
    <Row>
      <Col className='fs-14'>Classes</Col>
    </Row>
    <Row className='filterSummary align-items-center pb-3'>
      <Col className='col-8 d-flex align-items-baseline'>
        <div>Classes Selected</div>
        <div className='justify-content-center count d-flex m-1 rounded-circle'>
          {classes?.filter(x => x.selected)?.length}
        </div>
      </Col>
      {activeStep == 2 && <Col className='d-flex justify-content-end'><button onClick={() => setOpenClassSelect(true)} className="btn grid-icon-btn info-icon-btn">
        <FontAwesomeIcon icon={faEdit} />
      </button></Col>
      }
    </Row>
    <hr className='hr-border'></hr>
    <Row className='pt-3'>
      <Col className='fs-14 pb-2'>Primary Assignment</Col>
    </Row>
    <Row>
      <Col className='filterSummary pb-2'>
        {activeStep == 2 && primaryAssignmentId > 0 && <span className='word-overflow-break'>{primaryAssignmentName}</span>}
      </Col>
    </Row>
    <hr className='hr-border'></hr>
    <Row className='pt-3'>
      <Col className='fs-14 pb-2'>Mastery</Col>
    </Row>
    <Row>
      <Col className='filterSummary  pb-2'>
        {activeStep == 2 && <><span className='me-1'>Grading Threshold:</span><span className='fw-600'>{masteryScore}</span></>}
      </Col>
    </Row>
    <hr className='hr-border'></hr>
    <Row className='pt-3'>
      <Col className='fs-14 pb-2'>Assignments to Compare</Col>
    </Row>
    
    {activeStep == 2 && <>
      {comparers.filter(x=>x.show).map((compare) => {
        return(<><Row className='d-flex align-items-center pb-2'
          onMouseEnter={() => setHoveredRow(compare.index)}
          onMouseLeave={() => setHoveredRow(null)}
        >
          <Col className='filterSummary col-10'><span className='word-overflow-break'>{compare.name}</span></Col>
          {hoveredRow == compare.index && <Col className='col-2 filterSummary'>
            <button onClick={() => handleCompareDelete(compare.index)} className="btn grid-icon-btn danger-icon-btn">
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          </Col>
          }
        </Row></>);
      })
      }
      <Row>
        <Col className='d-flex justify-content-end'> <button disabled={!primaryAssignmentId || primaryAssignmentId ==0} onClick={() => generateReport()} className="btn btn-castleRed px-3">
          Run Report
        </button></Col>
      </Row>
    </>
    }
    {activeStep == 1 && <>
      <Row>
        <Col className='d-flex justify-content-end'>
          <button onClick={() => handleNextClick()} className={`btn btn-castleRed px-5 ${classes?.filter(x => x.selected).length > 0 ? '' : 'disabled'}`}>
              Next
          </button>
        </Col>
      </Row></>
    }

    {openClassSelect &&
      <Modal
        isOpen={openClassSelect}
        onClose={() => setOpenClassSelect(false)}
        contentWidth={'60%'}
        titleName={'Add/Remove Classes'}
      >
        <ClassSelects handleCancelClick={()=>setOpenClassSelect(false)} loadClassAssignments={(cIds)=>loadClassAssignments(cIds)} />
      </Modal>
    }
  </>);
};

FilterSummary.propTypes = {
  loadClassAssignments :PropTypes.func
};
export default FilterSummary;